import React from 'react'
import {connect} from 'react-redux'
import {Actions} from 'jumpstate'
import {browserHistory} from 'react-router'
import {Grid, Row, Button, Panel} from 'react-bootstrap'
import HorseAdBox from '../Common/HorseAdBox/HorseAdBox'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import NewAd from './NewAd'
import showToastr from '../../utils/showToastr'

import './Layout/AdsMainScreen.css'
import SwipeSlider from '../Common/SwipeSlider/SwipeSlider'

class AdsMainScreen extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      data: props.ads,
      isNewAdVisible: false
    }
    this.toggleNewAd = this.toggleNewAd.bind(this)
  }

  toggleNewAd () {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }

    if (!this.state.isNewAdVisible) {
      this.setState({isNewAdVisible: true})
    } else {
      this.setState({isNewAdVisible: false})
    }
  }

  componentWillMount () {
    if (this.props.ads.length) {
      this.setState({isLoading: false, data: this.props.ads})
    } else {
      Actions.listAds()
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.ads) {
      this.setState({isLoading: false, data: nextProps.ads})
    }
  }

  render () {
    const {auth, user} = this.props
    const {data, isLoading, isNewAdVisible} = this.state
    return (<Grid>
      {isLoading ? <HorseLoading />
      : <div id="AdsMainScreen">
        <Row>
          <Panel collapsible expanded={isNewAdVisible} className="NewAdBWraper">
            {isNewAdVisible && <NewAd isAuthenticated={auth.isAuthenticated} user={user} toggler={this.toggleNewAd} afterSave={() => Actions.listAds()} />}
          </Panel>
          <h2>آگهی <Button bsStyle={isNewAdVisible ? 'warning' : 'success'} className="AddNewAdB" onClick={() => this.toggleNewAd()} >{isNewAdVisible ? 'انصراف' : 'ثبت آگهی جدید'}</Button></h2>
          <p>
              در این بخش آگهی‌های <strong>فروش</strong>، <strong>اجاره شکم</strong> و <strong>کشش</strong> اسب‌های اصیل درج می‌گردد.
              برای دیدن آگهی‌های بیشتر در هر بخش، کافی است روی دکمه «بیشتر...» بزنید.
              لازم به ذکر است آیاهو هیچ مسئولیتی در قبال صحت اطلاعات مندرج در آگهی ندارد.
              لطفا پیش از پرداخت هر گونه وجه، با آگهی‌دهنده تماس گرفته و از صحت اطلاعات اطمینان حاصل نمایید.
            </p>
        </Row>
        <Row>
          <h2>آگهی‌های فروش {data.sale && data.sale.length >= 6 && <Button bsStyle="primary" onClick={() => browserHistory.push('/ads/sale')}>بیشتر ...</Button>}</h2>
          {data.sale
            ? <SwipeSlider height={350}>
              {data.sale.map(item => (<HorseAdBox key={item.id} ad={item} />))}
            </SwipeSlider>
            : <div className="AdNotFound">برای این بخش تا کنون آگهی ثبت نشده است.</div>}
        </Row>
        <Row>
          <h2>آگهی‌های اجاره شکم {data.belly_rental && data.belly_rental.length >= 6 && <Button bsStyle="primary" onClick={() => browserHistory.push('/ads/belly-rental')}>بیشتر ...</Button>}</h2>
          {data.belly_rental ? <SwipeSlider height={350}>
            {data.belly_rental.map((item, index) => (<HorseAdBox key={index} ad={item} />))}
          </SwipeSlider> : <div className="AdNotFound">برای این بخش تا کنون آگهی ثبت نشده است.</div>}
        </Row>
        <Row>
          <h2>آگهی‌های کشش {data.mate && data.mate.length >= 6 && <Button bsStyle="primary" onClick={() => browserHistory.push('/ads/mate')}>بیشتر ...</Button>}</h2>
          {data.mate ? <SwipeSlider height={350}>
            {data.mate.map((item, index) => (<HorseAdBox key={index} ad={item} />))}
          </SwipeSlider> : <div className="AdNotFound">برای این بخش تا کنون آگهی ثبت نشده است.</div>}
        </Row>
      </div>}
    </Grid>)
  }
}

AdsMainScreen.fetchData = () => {
  return Actions.listAds()
}

function mapStateToProps (state) {
  return {
    ads: state.ad.list,
    auth: state.auth,
    user: state.user.currentUser
  }
}

export default connect(mapStateToProps)(AdsMainScreen)



// WEBPACK FOOTER //
// ./src/components/Ad/AdsMainScreen.js